import React from 'react';
import { compose } from 'ramda';
import { Control } from '../Control';
import withField from '../withField';

import * as hoc from './hoc';
import * as constants from './constants';
import { Picker } from './components/Picker';

import style from './DatePicker.scss';

/**
 * @typedef {"PAST" | "FUTURE" | String} DatePickerRange

 * @param props {Object}
 * @param [props.input] {Object}
 * @param [props.meta] {Object}
 * @param [props.id] {String}
 * @param [props.label] {String}
 * @param [props.readOnly] {Boolean}
 * @param [props.className] {String}
 * @param [props.classNames] {Object}
 * @param [props.disabled] {Boolean}
 * @param [props.isPickersSeparate] {Boolean}
 * @param [props.range] {DatePickerRange} One of predefined value "PAST" (default) or "FUTURE" or custom range "<from>-<to>"
 * @example range={"1999-2030"}
 */
export const DatePickerDumb = ({
    /* rff render props */
    input,
    meta,

    /* user provided props */
    id,
    label,
    parse,
    setValue,
    readOnly,
    className,
    classNames,
    infoTooltip,
    disabled = false,
    isLabelAsteriskEnabled,
    isPickersSeparate = true,
    range = constants.RANGE.PAST
}) => (
    <Control
        id={id}
        meta={meta}
        label={label}
        animate={true}
        disabled={disabled}
        className={className}
        classNames={classNames}
        infoTooltip={infoTooltip}
        isBorderHidden={isPickersSeparate}
        isLabelAsteriskEnabled={isLabelAsteriskEnabled}
    >
        <div className={style.container}>
            <Picker
                parse={parse}
                setValue={setValue}
                disabled={disabled}
                readOnly={readOnly}
                type={constants.PICKERS.day}
                isBorderShown={isPickersSeparate}
                {...input}
            />
            <Picker
                parse={parse}
                setValue={setValue}
                disabled={disabled}
                readOnly={readOnly}
                type={constants.PICKERS.month}
                isBorderShown={isPickersSeparate}
                {...input}
            />
            <Picker
                range={range}
                parse={parse}
                setValue={setValue}
                disabled={disabled}
                readOnly={readOnly}
                type={constants.PICKERS.year}
                isBorderShown={isPickersSeparate}
                {...input}
            />
        </div>
    </Control>
);

export const enhance = compose(
    hoc.withFieldProps,
    withField
);

export const DatePicker = enhance(DatePickerDumb);
